import * as actions from "../actions/actionType";

const selectedResourceInit = {
  lessonId: null,
  itemId: null,
  resTypeId: null,
  resourceObj: null,
};

const initialState = {
  agResourceList: null,
  selectedResource: selectedResourceInit,
  navigatorState: 0,
  selectedResourceQuestions: null,
  selectedQuestionIndex: null,
  selectedQResponseList: null,
  responseCommentList: null,
};

export const autoGradeReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_AG_ITEM_LIST_SUCCESS:
      return {
        ...state,
        agResourceList: action.payload,
      };
    case actions.FETCH_AG_ITEM_QUESTIONS_SUCCESS:
      return {
        ...state,
        selectedResourceQuestions: action.payload,
      };
    case actions.UPDATE_SELECTED_RESOURCE:
      return {
        ...state,
        selectedResource: { ...state.selectedResource, ...action.payload },
      };
    case actions.FETCH_AG_QUESTION_RESPONSES_SUCCESS:
      return {
        ...state,
        selectedQResponseList: action.payload,
      };
    case actions.FETCH_RESPONSE_COMMENTS_SUCCESS:
      return {
        ...state,
        responseCommentList: action.payload?.data,
        selectedQResponseList: state.selectedQResponseList.map((response) =>
          response.result_id == action.payload?.id
            ? { ...response, comment_count: action.payload?.data?.length }
            : response
        ),
      };
    case actions.SUBMIT_USER_FEEDBACK_SUCCESS:
      return {
        ...state,
        responseCommentList: [
          ...state.responseCommentList,
          action.payload?.data,
        ],
        selectedQResponseList: state.selectedQResponseList.map((response) =>
          response.result_id == action.payload?.id
            ? { ...response, comment_count: response.comment_count + 1 }
            : response
        ),
      };
    case actions.RESET_SELECTED_RESOURCE:
      return {
        ...state,
        selectedResource: selectedResourceInit,
      };
    case actions.UPDATE_NAVIGATOR_STATE:
      return {
        ...state,
        navigatorState: action.payload,
      };
    case actions.UPDATE_SELECTED_QUESTION_INDEX:
      return {
        ...state,
        selectedQuestionIndex: action.payload,
      };
    default:
      return state;
  }
};
